export default __webpack_public_path__ + "static/media/attachmentIcon.9009e73b.svg";